export function addCurrent(assignedcalled) {
    return {
        type: 'ADD_CURRENT',
        assignedcalled,
    }
}
